var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.urlAcervo
      ? _c("iframe", {
          staticClass: "default-iframe",
          attrs: {
            showinfo: "0",
            width: "100%",
            height: "800",
            rel: "0",
            src: _vm.urlAcervo,
            frameborder: "0",
            allow:
              "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
            allowfullscreen: "allowfullscreen",
            modestbranding: "1"
          }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b97bf30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b97bf30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/AcervoFundiario.vue
// module id = null
// module chunks = 